import { render, staticRenderFns } from "./RequesterReviewLifecycle.vue?vue&type=template&id=7dce19fa"
import script from "./RequesterReviewLifecycle.vue?vue&type=script&lang=js"
export * from "./RequesterReviewLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports